import { bg, lightLiteral } from '../theme/semanticTokens';

/**
 * The ONE set of splash values (2026-09-25 splash audit). Everything that
 * hands off to or from the splash — the static preloader in public/index.html,
 * SplashOverlay, the sign-in logo morph and the auth shell's background during
 * the morph — reads these, so no two layers ever disagree on color or font
 * (the audit's #1 and #3 flicker causes). Keep public/index.html in sync by
 * hand: it can't import JS (guard: splashTokens.test.js).
 */
/**
 * Splash + app canvas background = the theme's canvas (slate-50 in Light, Graphite canvas in Dark). The sign-in
 * page warms to it before the splash covers it (AuthScreenShell), so a literal here flashed white in dark (KAN-304).
 */
export const SPLASH_BG = bg.canvas;
/** The same colour as a real value, for the static preloader in public/index.html (Light; dark has its own rule there). */
export const SPLASH_BG_LIGHT = lightLiteral.bg.canvas;
/** Self-hosted, preloaded wordmark face (declared in public/index.html). */
export const SPLASH_FONT = "'Bricolage Splash', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
/** Attribute on SplashOverlay's wordmark so the logo morph can land on it exactly. */
export const SPLASH_WORDMARK_ATTR = 'data-splash-wordmark';
/** SplashOverlay's opacity fade (in and out). Sign-out waits this long so its teardown happens under a fully opaque splash. */
export const SPLASH_FADE_MS = 220;
/**
 * Legacy Vex shimmer gradient (RD-SEC-021d / KAN-657 removed the shine).
 * Kept exported so older imports / docs don't break; unused by live splash UI.
 */
export const SPLASH_VEX_SHINE_GRADIENT = 'linear-gradient(110deg, #1e3a8a 15%, #60a5fa 50%, #1e3a8a 85%)';
/**
 * Staged hand-off of the wordmark + rail against the ground (KAN-304 follow-up). Out (no glide target): the
 * wordmark/rail fade over PLAIN_MARK_OUT, the ground starts PLAIN_GROUND_DELAY later (total = delay + SPLASH_FADE_MS,
 * +40ms vs the old single 220ms fade). In (splash returns over a live screen, e.g. the silent update): the mark
 * waits MARK_IN_DELAY (ground ~0.8 opaque on the 220ms ease-out), then fades in over MARK_IN.
 */
export const SPLASH_PLAIN_MARK_OUT_MS = 90;
export const SPLASH_PLAIN_GROUND_DELAY_MS = 40;
export const SPLASH_MARK_IN_DELAY_MS = 100;
export const SPLASH_MARK_IN_MS = 120;
